const hostnameRE = /(uk|flink)/;

export const isUK = hostnameRE.test(window.location.hostname);
